import React from 'react';

function Notfound(props) {
    return (
        <h1>Not Found</h1>
    );
}

export default Notfound;
